import React, { useState } from 'react';
import { ConfigProvider, Segmented } from '@duxton-web/ui';
import styled from 'styled-components';

import { useExperimentContext } from '../../contexts/experiment-context';
import { toExperimentDto } from '../../domain/experiment/transform';
import { getAxaCompatibilityInfo } from '../../utils';
import Estimate from '../estimate';
import Metrics from '../metrics';
import Treatment from '../treatment';
import { JsonCard } from '@/pages/ExperimentFormV2/Sections/JsonPreview';

const VisualSetupContent = () => {
  const { experiment, configurations } = useExperimentContext();

  // Check if this is an AXA-incompatible timeslice experiment
  const { isAxaIncompatible } = getAxaCompatibilityInfo(
    configurations,
    experiment,
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        flexGrow: 1,
        overflow: 'hidden auto',
      }}
    >
      <Treatment />
      <Estimate />
      <Metrics isAxaIncompatible={isAxaIncompatible} />
    </div>
  );
};

const SetupForm = () => {
  const experimentContext = useExperimentContext();
  const { experiment, configurations } = experimentContext;

  const [currentTab, setCurrentTab] = useState('visual-setup');

  return (
    <div
      style={{
        flexGrow: 1,
        overflow: 'hidden',
        padding: '16px 24px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        gap: 16,
      }}
    >
      <ConfigProvider
        theme={{
          components: {
            Segmented: {
              trackBg: 'rgb(232, 232, 232)',
            },
          },
        }}
      >
        <Segmented
          value={currentTab}
          onChange={(value) => setCurrentTab(value)}
          size="small"
          block
          options={[
            { label: 'Visual Setup', value: 'visual-setup' },
            { label: 'JSON', value: 'json' },
          ]}
        />

        {currentTab === 'visual-setup' ? (
          <VisualSetupContent />
        ) : (
          <div style={{ flexGrow: 1, overflow: 'hidden auto' }}>
            <JsonCard
              title={null}
              subtitle={null}
              payload={toExperimentDto(experiment, configurations)}
              defaultOpen={true}
              style={{ border: '1px solid #E8E8E8' }}
            />
          </div>
        )}
      </ConfigProvider>
    </div>
  );
};

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const FormBody = styled.div`
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 24px;
`;

export const FormSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  isolation: isolate;
  z-index: 1;
`;

export default SetupForm;
